import "./App.css";
import { AuthProvider, useDescope, useSession, useUser } from "@descope/react-sdk";
import { Descope } from "@descope/react-sdk";

const AppRoot = () => {
	return (
		<AuthProvider
			projectId="P3BeYZwGTUwgxbdyahuqlbm6Sx25"
		>
			<App />
		</AuthProvider>
	);
};

function App() {
	const { isAuthenticated } = useSession();

	// user: user object with all the user details such as email, name etc.
	// isUserLoading: boolean - Use this for showing loading screens while objects are being loaded
	const { user } = useUser();

	// logout - call logout to logout the user (deletes all session state)
	const { logout } = useDescope();


	if (isAuthenticated) {
		return (
			<>
				<div className="done">
					<p>
						Done
						<br />
						{user?.email || ""}
						<br />
						<button class="backButton" href="#" onClick={logout}>
							back
						</button>
					</p>
				</div>
			</>
		)
	}
	return (
		<div className="App">

			{
				<Descope
					flowId="promptauth"
					onSuccess={(e) => {
						const obj = {
							firstName: e.detail.user.name ? e.detail.user.name.split(" ")[0] : "",
							lastName: e.detail.user.name ? e.detail.user.name.split(" ").splice(1).join(" ") : "",
							name: e.detail.user.name,
							email: e.detail.user.email,
							userId: e.detail.user.userId,
							origin: "PromptAuth",
						};

						window.analytics.identify(e.detail.user.userId, obj);
						window.analytics.track("pre_order_success", obj);
					}}
					onError={(e) => console.log("Could not log in!")}
					theme="light"
				/>
			}
		</div>
	);
}

export default AppRoot;
